import { replaceVariableInStep } from './validateResponse'

// eslint-disable-next-line import/prefer-default-export
export async function initStepsReactivation(_this) {
  const { steps } = _this.props

  steps[0].sentence = replaceVariableInStep(steps[0].sentence, _this)

  const rawSteps = steps

  return {
    rawSteps,
  }
}
